import loadable from '@loadable/component';

const RegisterLoadable = loadable(() => import(/* webpackChunkName: 'register' */ './Register'));

const Register = () => <RegisterLoadable />;

export default Register;
